'use client';

import React from 'react';
import { useAlertContext } from '@/presentation/context/alert';

export const SidebarOuter = ({ children }: { children: React.ReactNode }) => {
  const { alertText } = useAlertContext();
  // If we have an alert, adjust the top offset
  return (
    <aside
      className={`fixed z-10 bottom-0 -left-px right-0 sm:right-auto sm:top-[5.5rem] ${
        alertText ? 'md:top-[8.5rem]' : 'md:top-[6.5rem]'
      } w-full sm:w-auto bg-gray-50 flex border-t sm:border-t-0 sm:border-r border-gray-200`}
    >
      {children}
    </aside>
  );
};
